<p-dialog
  [(visible)]="visible"
  [modal]="true"
  [dismissableMask]="false"
  styleClass="generic-success-container"
  (onHide)="close()"
>
  <ng-template pTemplate="header">
    <div class="modal-header">
      <h2>User Request</h2>
    </div>
  </ng-template>

  <div class="modal-body">
    <div class="check-icon-image" *ngIf="showCheckmark">
      <img
        ngSrc="assets/icons/check.svg"
        alt="Success Icon"
        class="circle-img"
        width="48"
        height="48"
      />
    </div>

    <p class="success-msg">User Request Accepted</p>
  </div>

  <ng-template pTemplate="footer">
    <div class="footer-buttons">
      <button pButton label="Close" class="p-button-warning" (click)="close()" *ngIf="showCloseButton"></button>
    </div>
  </ng-template>
</p-dialog>